"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MrsRta_exports = {};
__export(MrsRta_exports, {
  MrsRta: () => MrsRta,
  MrsRtaPro: () => MrsRtaPro
});
module.exports = __toCommonJS(MrsRta_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_inventory_enums = require("@cartographerio/inventory-enums");
var import_core = require("../../core/index.js");
var import_helpers = require("./helpers.js");
function rtaMap(mapId, title) {
  return (0, import_core.mapSchemaWithDefaults)({
    mapId,
    title,
    layers: [
      (0, import_topo_map.pointLayer)({
        layerId: (0, import_topo_map.unsafeMapLayerId)(mapId),
        title,
        source: (0, import_core.cartographerSourceWithDefaults)({
          layerId: (0, import_topo_map.unsafeMapLayerId)(mapId),
          attribution: []
        }),
        defaultAttribute: "finalRiverType",
        defaultZOrder: "timestamp",
        attributes: [
          (0, import_topo_map.attributeGroup)({
            label: "Survey Details",
            attributes: [
              (0, import_topo_map.stringAttr)({
                attributeId: "riverName",
                label: "River",
                buckets: "auto"
              }),
              (0, import_topo_map.stringAttr)({
                attributeId: "reachName",
                label: "Reach",
                buckets: "auto"
              }),
              (0, import_topo_map.stringAttr)({
                attributeId: "projectName",
                label: "Project Name",
                buckets: "auto"
              }),
              (0, import_topo_map.stringAttr)({
                attributeId: "projectCode",
                label: "MoRPh Correlation Code",
                buckets: "auto"
              }),
              (0, import_topo_map.stringAttr)({
                attributeId: "wfdWaterBodyId",
                label: "WFD Water Body ID",
                buckets: "auto"
              }),
              (0, import_topo_map.teamAttr)("teamId", "Team"),
              (0, import_topo_map.surveyAttr)("surveyId", "Survey"),
              (0, import_topo_map.timestampAttr)({
                attributeId: "timestamp",
                label: "Date/Time",
                buckets: "auto"
              })
            ]
          }),
          (0, import_topo_map.attributeGroup)({
            label: "River Type",
            attributes: [(0, import_helpers.riverTypeAttr)("finalRiverType", "River Type")]
          }),
          (0, import_topo_map.attributeGroup)({
            label: "Calculations",
            attributes: [
              (0, import_helpers.riverCategoryAttr)("riverCategory", "River Category"),
              (0, import_topo_map.numberAttr)({
                attributeId: "a1",
                label: "A1: Braiding Index",
                decimalPlaces: 3,
                buckets: [
                  (0, import_topo_map.rangeBucket)(null, 1.1, import_topo_map.marker.quality(6 / 12)),
                  (0, import_topo_map.rangeBucket)(1.1, 1.5, import_topo_map.marker.quality(5 / 12)),
                  (0, import_topo_map.rangeBucket)(1.5, null, import_topo_map.marker.quality(4 / 12))
                ]
              }),
              (0, import_topo_map.numberAttr)({
                attributeId: "a2",
                label: "A2: Sinuosity Index",
                decimalPlaces: 3,
                buckets: [
                  (0, import_topo_map.rangeBucket)(null, 1.05, import_topo_map.marker.quality(6 / 12)),
                  (0, import_topo_map.rangeBucket)(1.05, 1.5, import_topo_map.marker.quality(5 / 12)),
                  (0, import_topo_map.rangeBucket)(1.5, null, import_topo_map.marker.quality(4 / 12))
                ]
              }),
              (0, import_topo_map.numberAttr)({
                attributeId: "a3",
                label: "A3: Anabranching Index",
                decimalPlaces: 3,
                buckets: [
                  (0, import_topo_map.rangeBucket)(null, 1.05, import_topo_map.marker.quality(6 / 12)),
                  (0, import_topo_map.rangeBucket)(1.05, 1.5, import_topo_map.marker.quality(5 / 12)),
                  (0, import_topo_map.rangeBucket)(1.5, null, import_topo_map.marker.quality(4 / 12))
                ]
              }),
              (0, import_topo_map.stringAttr)({
                attributeId: "a4",
                label: "A4: Level of Confinement",
                buckets: [
                  (0, import_topo_map.lookupBucket)(import_inventory_enums.MrsRtaLevelOfConfinementEnum.Confined, import_topo_map.marker.quality(4 / 12), "Confined"),
                  (0, import_topo_map.lookupBucket)(import_inventory_enums.MrsRtaLevelOfConfinementEnum.PartlyConfined, import_topo_map.marker.quality(5 / 12), "Partly confined"),
                  (0, import_topo_map.lookupBucket)(import_inventory_enums.MrsRtaLevelOfConfinementEnum.Unconfined, import_topo_map.marker.quality(6 / 12), "Unconfined")
                ]
              }),
              (0, import_topo_map.numberAttr)({
                attributeId: "a5",
                label: "A5: Reach Valley Gradient",
                decimalPlaces: 5,
                unit: "m/m",
                buckets: [
                  (0, import_topo_map.rangeBucket)(null, 0.01, import_topo_map.marker.quality(4 / 12)),
                  (0, import_topo_map.rangeBucket)(0.01, null, import_topo_map.marker.quality(6 / 12))
                ]
              }),
              (0, import_topo_map.stringAttr)({
                attributeId: "a6",
                label: "A6: Bedrock Reach?",
                buckets: "auto"
              }),
              (0, import_helpers.particleSizeAttr)("a7", "A7: Coarsest Bed Material", true),
              (0, import_helpers.particleSizeAttr)("a8", "A8: Average Bed Material", false),
              (0, import_helpers.riverTypeAttr)("calculatedRiverType", "Calculated River Type"),
              (0, import_helpers.riverTypeAttr)("overriddenRiverType", "Overridden River Type")
            ]
          })
        ]
      })
    ]
  });
}
const MrsRta = rtaMap((0, import_topo_map.unsafeMapId)("mrsRta"), "River Type");
const MrsRtaPro = rtaMap((0, import_topo_map.unsafeMapId)("mrsRtaPro"), "River Type");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  MrsRta,
  MrsRtaPro
});
//# sourceMappingURL=MrsRta.js.map
